import useModalStore from '@/store/modal.store'
import React, { HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

const Modal = ({ children, ...props }: Props) => {
  const { onClose } = useModalStore()

  const handleBackgroundClick = () => {
    onClose()
  }

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation() // Prevents the click from bubbling to the background
  }

  return (
    <div
      onClick={handleBackgroundClick}
      {...props}
      className='fixed inset-0 flex items-center justify-center w-full h-full bg-black/75 z-10 p-4'
    >
      <div onClick={handleContentClick}>
        {children}
      </div>
    </div>
  )
}

export default Modal
